import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Singapore NRIC validator following Single Responsibility Principle
 */
export class NricValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Singapore NRIC',
      pattern: /^[STFG]\d{7}[A-Z]$/i,
      length: 9
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'NRIC format must start with S, T, F, or G, followed by 7 digits and a letter'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const expectedChecksum = ChecksumCalculator.calculateNricChecksum(upperCaseId);
    const actualChecksum = upperCaseId.slice(-1);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(
        `Invalid NRIC checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`
      );
    }

    return ValidationResult.valid('Valid NRIC');
  }
}